import type { RouteRecordRaw } from 'vue-router';

export const OUTBOUND_ROUTER: RouteRecordRaw[] = [
  {
    path: '/outbound',
    component: () => import('@/components/layout/Default.vue'),
    meta: { requiresAuth: true },
    redirect: '/outbound/list',
    children: [
      {
        path: 'list',
        component: () => import('@/modules/movement/outbound/views/OutboundList.vue'),
        name: 'Outbound List',
        meta: {
          title: '출고 관리',
        },
      },
      {
        path: 'return-create',
        component: () => import('@/modules/movement/outbound/views/OutboundReturnCreate.vue'),
        name: 'Outbound Return Create',
        meta: {
          title: '반품출고 등록',
        },
      },
    ],
  },
];
